import { Navigate, Outlet } from 'react-router-dom';

import { useAuthContext } from '../../hooks/useAuthContext';

export default function ProtectedRoute() {
  const { user, token } = useAuthContext();

  if (!user || !token) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
}
